<template>
  <img :src="iconSrc" :style="style" />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  size: {
    type: [Number, String],
    default: null,
  },
})

const iconSrc = computed(() => '/gfx/worker-classification-override.svg')

const style = computed(() => {
  if (props.size === null) {
    return {}
  }
  return {
    height: 'auto',
    maxWidth: `${props.size}px`,
  }
})
</script>
